import React from 'react';
import { useSelector } from 'react-redux';
import { FormHelperText, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';
import classes from './form.module.scss';
import { useWindowSize } from '../../../utils/hooks';

function ContractForm(props) {
  const { values, errors, touched, changeHandler } = props;
  const currencies = useSelector((state) => state?.constFromApi?.currencies);
  const size = useWindowSize();

  return (
    <div
      className={`d-flex ${
        size.width > MOBILE_BREAKPOINT ? 'flex-row' : 'flex-column'
      } justify-content-center align-items-start gap-2`}
    >
      <div className="d-flex flex-column align-items-center">
        <span className={classes.fieldLabel}>Hourly Rate</span>
        <TextField
          variant="outlined"
          value={values.hourly}
          onChange={(e) => changeHandler('hourly', e.target.value?.replace(/[^0-9]/g, ''))}
          classes="w-100 w-sm-auto"
          sx={{
            width: {
              sm: '100%',
              md: '100px'
            },
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiOutlinedInput-root': {
              borderRadius: 0
            }
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">/ hr</InputAdornment>
          }}
          error={touched.hourly && !!errors.hourly}
          helperText={touched.hourly && errors.hourly}
        />
      </div>
      <div className="d-flex flex-column align-items-center">
        <span className={classes.fieldLabel}>Daily Rate</span>
        <TextField
          variant="outlined"
          value={values.daily}
          onChange={(e) => changeHandler('daily', e.target.value?.replace(/[^0-9]/g, ''))}
          sx={{
            width: {
              sm: '100%',
              md: '100px'
            },
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiOutlinedInput-root': {
              borderRadius: 0
            }
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">/ day</InputAdornment>
          }}
          error={touched.daily && !!errors.daily}
          helperText={touched.daily && errors.daily}
        />
      </div>
      <div className="d-flex flex-column align-items-center">
        <span className={classes.fieldLabel}>Currency</span>
        <Autocomplete
          value={values.currency}
          disableClearable
          options={currencies || []}
          onChange={(e, value) => changeHandler('currency', value?.label)}
          classes="w-100 w-sm-auto"
          sx={{
            width: {
              sm: '100%',
              md: '100px'
            },
            '& legend': { display: 'none' },
            '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
              width: '100%'
            },
            '& fieldset': { top: 0 },
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: 0
            }
          }}
          renderOption={(prop, option) => (
            <li {...prop} key={option.key}>
              {option.label}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              sx={{
                width: {
                  sm: '100%',
                  md: '100px'
                }
              }}
              {...params}
            />
          )}
        />
        {touched.currency && errors.currency && <FormHelperText error>{errors.currency}</FormHelperText>}
      </div>
    </div>
  );
}

export default ContractForm;
